// Copyright (c) Ping. All rights reserved.

import type { NotesSort } from './types';

export const notesStrings = {
  screenTitle: 'Notes',
  searchPlaceholder: 'Search notes',
  searchClearLabel: 'Clear search',
  emptyTitle: (query: string): string =>
    query.length > 0 ? 'No notes match your search' : 'No notes yet',
  emptyBody: 'Capture an idea or share a quick reference with your team.',
  errorTitle: "Couldn't load notes",
  errorRetry: 'Try again',
  newNoteCta: 'New note',
  newFolderCta: 'New folder',
  newNoteTitle: 'New note',
  newFolderTitle: 'New folder',
  noteTitleLabel: 'Title',
  noteTitlePlaceholder: 'Untitled note',
  noteBodyLabel: 'Body',
  noteBodyPlaceholder: 'Start writing…',
  folderTitleLabel: 'Folder name',
  folderTitlePlaceholder: 'Folder name',
  saveCta: 'Save',
  cancelCta: 'Cancel',
  doneCta: 'Done',
  sort: (sort: NotesSort): string => {
    switch (sort) {
      case 'mostRecent':
        return 'Most recent';
      case 'title':
        return 'Title';
    }
  },
  selection: {
    enter: 'Select',
    exit: 'Done',
    bulkDelete: 'Delete',
    bulkMove: 'Move to folder',
    clear: 'Clear selection',
    countLabel: (count: number): string => (count === 1 ? '1 selected' : `${count} selected`),
  },
  optionMenu: {
    rename: 'Rename',
    move: 'Move to folder',
    duplicate: 'Duplicate',
    delete: 'Delete',
  },
  editor: {
    saved: 'Saved',
    saving: 'Saving…',
    unsaved: 'Unsaved changes',
  },
} as const;

export type NotesStrings = typeof notesStrings;
